var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_634_1550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.175 36.2242C29.7651 36.2242 38.35 28.1151 38.35 18.1121C38.35 8.10906 29.7651 0 19.175 0C8.58494 0 0 8.10906 0 18.1121C0 28.1151 8.58494 36.2242 19.175 36.2242Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_634_1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7835 36.2242V25.1794L-10.5991 36.2242H12.7835ZM-19.1748 24.1494V32.1743L-2.1832 24.1494H-19.1748ZM-19.1748 4.05047V12.0753H-2.1832L-19.1748 4.05047ZM25.5669 0V11.0435L48.9501 0H25.5669ZM57.5252 32.1743V24.1494H40.5342L57.5252 32.1743ZM40.5259 12.0747H57.5252V4.04503L40.5259 12.0747ZM12.7835 11.0435V0H-10.5991L12.7835 11.0435ZM25.5669 36.2242H48.9501L25.5669 25.1806V36.2242Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.1748 24.1494H-2.1832L-19.1748 32.1743V36.2242L6.39186 24.1494H12.1092L-13.4575 36.2242H-10.5991L12.7835 25.1794V36.2242H15.3402V21.7345H-19.1748V24.1494ZM12.7835 11.0435L-10.5991 0H-19.1748L6.39186 12.0747H0.675154L-19.1748 2.70051V4.05047L-2.1832 12.0753H-19.1748V14.4903H2.92949H12.7835H15.3402V0.000603736H12.7835V11.0441V11.0435ZM57.5252 0L31.9585 12.0747H26.2418L51.8085 0H48.9501L25.5669 11.0435V0H23.0102V14.4897H25.5669H35.4132H57.5252V12.0747H40.5259L57.5252 4.04503V0ZM23.0102 36.2242H25.5669V25.1806L48.9501 36.2242H57.5252L31.9585 24.1494H37.6752L57.5252 33.5243V32.1743L40.5342 24.1494H57.5252V21.7345H23.0102V36.2242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.1748 36.2242H-13.4575L12.1092 24.1494H6.39186L-19.1748 36.2242ZM57.5252 0H51.8085L26.2418 12.0747H31.9585L57.5252 0ZM6.39186 12.0747L-19.1748 0V2.70051L0.675154 12.0747H6.39186ZM25.5669 14.4897H23.0102V0H15.3402V14.4897H12.7835H2.92949H-19.1748V21.7345H15.3402V36.2242H23.0102V21.7345H57.5252V14.4897H35.4132H25.5669ZM31.9585 24.1494L57.5252 36.2242V33.5243L37.6752 24.1494H31.9585Z",
    fill: "#CF142B"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/En.6aacb66bd2caeffcc7eceba110040c6e.svg";